(function (angular) {
    'use strict';

    /**
     * Rebates modal related services
     *
     * AARON BIXLY SERVICE, ITS DOPE JAVASCRIPT STUFF
     */
    angular
        .module('enervee.fastTrack')
        .factory('FastTrackProductsModalService', FastTrackProductsModalService);

    FastTrackProductsModalService.$inject = [
        'CategoriesService',
        'EnerveeRebateService',
        'UtilService',
    ];

    function FastTrackProductsModalService(
        CategoriesService,
        EnerveeRebateService,
        UtilService
    ) {
        var _productsToClaim = [{}];
        var _pub = {
            addProduct: addProductToClaim,
            removeProduct: removeProductToClaim,
            retrieveProducts: retrieveProductsToClaim,
            retrieveRawProducts: retrieveRawProductsToClaim,
            setProducts: setProductsToClaim,
            submitProducts: submitProductsToClaim,
        };

        return _pub;

        /**
         * Add the given product to the list of products to claim. If no product
         * is given, add an empty object to the list instead.
         *
         * @param {Object} [product={}] - The product to add to the list.
         */
        function addProductToClaim(product) {
            if (angular.isUndefined(product) ||
                angular.isObject(product) && Object.getOwnPropertyNames(product).length === 0) {
                _productsToClaim.push({});
            } else {
                _productsToClaim.push(_buildProductToClaim(product));
            }
        }

        /**
         * Remove the ProductToClaim with the given index from the array.
         *
         * @param {number} productIndex
         */
        function removeProductToClaim(productIndex) {
            _productsToClaim.splice(productIndex, 1);
            if (_productsToClaim.length === 0) {
                addProductToClaim();
            }
        }

        /**
         * Retrieve the products that the user wishes to claim.
         *
         * @return {ProductToClaim[]}
         */
        function retrieveProductsToClaim() {
            return _productsToClaim;
        }

        /**
         * Retrieve the standard product object for all of the products selected.
         *
         * @return {Object[]}
         */
        function retrieveRawProductsToClaim() {
            return UtilService.reduceToProperty(_productsToClaim, 'selectedProduct');
        }

        /**
         * Replace the products the user wants to claim with a new array of raw
         * product data.
         *
         * @param {Object[]} productArray
         */
        function setProductsToClaim(productArray) {
            _productsToClaim.splice(0, _productsToClaim.length);
            if (angular.isArray(productArray) && productArray.length > 0) {
                productArray.forEach(function(product) {
                    addProductToClaim(product);
                });
            } else {
                addProductToClaim();
            }
        }

        /**
         * Submit the products selected and return the response from the server.
         *
         * @return {Promise}
         */
        function submitProductsToClaim() {
            return EnerveeRebateService.submitProductsToClaim(retrieveRawProductsToClaim());
        }

        /**
         * Create a ProductToClaim object from raw product data.
         *
         * @param {Object} product
         * @return {ProductToClaim}
         * @private
         */
        function _buildProductToClaim(product) {
            return {
                categoryName: CategoriesService.getCategoryById(product.category_id).code,
                isCategorySelected: true,
                isProductSelected: true,
                loadingProducts: false,
                modelList: [product],
                modelNumber: product.brand + ' ' + product.model_number,
                selectedProduct: product,
            };
        }
    }

    /**
     * A product that is being chosen for a claim
     * @typedef {Object} ProductToClaim
     * @property {string} categoryName - The code name for the product's category
     * @property {boolean} isCategorySelected - Indicates whether the category has been selected for the product.
     * @property {boolean} isProductSelected - Indicates whether the product has been selected.
     * @property {boolean} loadingProducts - Indicates whether we are trying to load possible products.
     * @property {Object[]} modelList - An array of possible products for selected category and modelNumber.
     * @property {string} modelNumber - The product brand and model number to search for.
     * @property {Object} selectedProduct - The product that the user has chosen to claim.
     */
})(angular);